export default (editor, opts = {}) => {
    const DOMC = editor.DomComponents;
    const BM = editor.BlockManager;
    const TYPE = DOMC.getType('C-SELECT');
    const MODEL = TYPE.model;
    const VIEW = TYPE.view;

    var model = MODEL.extend({

        defaults:{
            ...MODEL.prototype.defaults,  
            attributes:{
                'data-slg-type':'C-SELECT-DAY',
                name:"day",
                placeholder:'Day',
                required:true
            },
            options:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31],
          
        },
    },{
        isComponent(el) {
            if(el && el.getAttribute && el.getAttribute('data-slg-type') == "C-SELECT-DAY")
                    return { type:'C-SELECT-DAY' }
        }
    });

    var view = VIEW.extend({
        // Extend view 
    });

    DOMC.addType('C-SELECT-DAY', {
        model:model,
        view:view,
    });

    /* bm.add('B-SELECT-DAY', {
        label: `
                <p class="b-text-label mt-3">DAY</p>
              `,
        content: { 
          type: 'C-SELECT-DAY',
         },
        // media: '<svg>...</svg>',
    }); */
};
  